import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'
import { MediaObject } from 'types'

/**
 * Preview reads `post.media_objects` for native carousel UI. `customPreviewContent`
 * replaces that and hides dots/swipe — omit it and pass this minimal stub instead.
 */
export function previewPostForComparisonMedia(mediaObjects: MediaObject[], content?: string): ScheduledPostShow {
  return { media_objects: mediaObjects, content: content } as ScheduledPostShow
}
